class Draad_osm_map {
    constructor( map ) {
        this.mapWrapperNode = map;
        this.mapNode = this.mapWrapperNode.querySelector( '.map__element' );

        // Scope markers to the current map wrapper
        this.markers = this.mapWrapperNode.querySelectorAll( '.map__marker' );
        if ( this.markers.length <= 0 ) {
            return;
        }

        this.map = null;

        // Add custom CSS variables
        this.mapComputed = getComputedStyle( this.mapNode );
        this.mapImage = this.mapComputed.getPropertyValue( '--map-image' ).replace(/^"|"$/g, '').trim() || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
        this.markerIcon = this.mapComputed.getPropertyValue( '--marker-icon' ).replace(/^"|"$/g, '').trim() || 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png';
        this.markerWidth = this.mapComputed.getPropertyValue( '--marker-width' ) || '30';
        this.markerHeight = this.mapComputed.getPropertyValue( '--marker-height' ) || '35';
        this.markerAnchor = this.markerWidth / 2;

        this.buildMap();
        this.setMarkers();
    }

    buildMap() {
        let mapData = JSON.parse( this.mapNode.dataset.draadMapData ); // Get the map data from the data attribute

        this.map = L.map( this.mapNode ).setView( [ mapData.lat, mapData.lng ], mapData.zoom ); // Initialize the map with the center and zoom level

        // Set the map tile layer
        L.tileLayer( this.mapImage, {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
        } ).addTo( this.map );
    }

    setMarkers() {
        // Check if there are any markers
        this.markers?.forEach( marker => {
            let markerData = JSON.parse( marker.textContent ); // Get the marker data from the text content

            let locationPin = L.icon( {
                iconUrl: this.markerIcon, // URL to the marker icon
                iconSize: [ this.markerWidth, this.markerHeight ], // Size of the marker icon
                iconAnchor: [ this.markerWidth / 2, this.markerHeight / 2 ], // Point of the icon to set on marker location
                popupAnchor: [ 0, -this.markerHeight / 2 ], // Point from which the popup should open
            } );

            const leafletMarker = L.marker( [ markerData.lat, markerData.lng ], { icon: locationPin }).addTo( this.map ); // Add the marker to the map

            // Bind the popup to the marker and set the content
            const popupContent = markerData.default_label;
            leafletMarker.bindPopup( popupContent, {
                className: 'map__popup',
            } );
        } );
    }
}

// Initialize the map when the DOM is loaded
document.addEventListener( "DOMContentLoaded", function () {
    const maps = document.querySelectorAll( ".map" );
    if ( ! L ) {
        console.error( 'Leaflet library is not loaded.' );
        return;
    }

    maps?.forEach( map => {
        new Draad_osm_map( map );
    } );
} );